import { Injectable, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { newJob } from '../model/newJob';
import { Users } from '../model/users';
import { StopWatchComponent } from '../stop-watch/stop-watch.component';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  
  constructor() {
    
  }
  

  stime:string=""

  saveStartTime(stime:string)
  {
    this.stime=stime
  }
nst:string=""
  savenewST(st:string)
  {
    this.nst=st;
  }
//save show pause condition
showPauseButton:boolean=false
saveShowPauseCondition(showPauseButton:boolean)
{
this.showPauseButton=showPauseButton;
}

  //Shared mvaDetails from newEntry when new jjob is created
  mvaData:any
  getMVAData(mvaData:any)
  {
   this.mvaData=mvaData.Model;
   //console.log(mvaData.Model);
  }
  //we passed booleancondition of workInprogress in clockShow and in SelectFeature.ts this clockShow accessed
  //and according to it we binded condition to clock
  clockShow: boolean;
  clockDisplayOnSelectFeatureComponent(workInProgressClicked: boolean) {
    this.clockShow = workInProgressClicked;
  }

  //This is second senario where we can store object of newJob from newScanner component
  //on selectFeature we can access newjobObj1 by shared service object
  sharedfromNewEntrynewjobObj1: newJob;
  success=false
  newScannerObjPassingOnSharedService(newjobObj: newJob) {
    this.success=true
    this.sharedfromNewEntrynewjobObj1 = newjobObj;
    //console.log(this.sharedfromNewEntrynewjobObj1)

  }
 //after click on clock from select feature component object will store here below method and
 //On stop watch init method line 76 will acces object from this shared service
  newJobObjectPassedFromSelectFeatureComponetforPOST:newJob;
  postDataObjStoredOnSharedService(newJobObj: newJob)
  {
    this.newJobObjectPassedFromSelectFeatureComponetforPOST=newJobObj;
  //console.log("From shared service "+newJobObj)
  }
  wc:boolean=true
  wip:boolean=false
  buttonClicked(wc:any,wip:any)
  {
    this.wc=wc;
    this.wip=wip
  }
  userData:any
  wwidAndUsername(res:any)
  {
    this.userData=res
   // console.log(this.userData)
  }

  usercountry :any
  userstate :any
  countryandstate(res:any)
  {
    console.log("country")
   // console.log(res)
    this.usercountry=res.country;
    this.userstate =res.state;
    
  }

  selectedoption:any;
 getSelectedOption(selectedoption:any){
    this.selectedoption = selectedoption;
   // console.log(this.selectedoption);
  }
  sharedsubdate:Date;
  setsubdate(subdate:any)
  {
      this.sharedsubdate = subdate;
  }
  // subletSupplierList:any;
  // postSubletSupplierData(supplierList : any)
  // {
  //   this.subletSupplierList=supplierList;
  // }

}
